//@author: travis
import { TypeManagerDecorator } from "../../../main/type.map.service";
import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    ElementRef,
    Input,
    NgZone,
    OnInit,
    ViewEncapsulation,
} from "@angular/core";
import { LynxPrefs, LynxPrefsService } from "../lynx.prefs.service";

@TypeManagerDecorator("s25-ng-lynx-home")
@Component({
    selector: "s25-ng-lynx-home",
    template: `
        @if (this.init) {
            <div class="c-margin-left--single">Welcome to Lynx in 25live!</div>
            <div class="panel">
                <table class="lynx-table">
                    @for (setting of systemSetup; track setting) {
                        <tr>
                            <td>{{ setting.name }}</td>
                            <td>{{ setting.value }}</td>
                        </tr>
                    }
                </table>
            </div>
            <div class="panel">
                <s25-ng-lynx-status></s25-ng-lynx-status>
            </div>
        }
    `,
    styles: `
        .lynx-table {
            width: 100%;
            border-collapse: collapse;
            margin: 25px 0;
            font-size: 0.9em;
            font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
            min-width: 400px;
            box-shadow: 0 0 20px rgba(0, 0, 0, 0.15);
        }
    `,
    encapsulation: ViewEncapsulation.Emulated,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class S25LynxHomeComponent implements OnInit {
    init: boolean = false;
    systemSetup: {
        name: LynxPrefs.PrefNames;
        value: string;
    }[] = [];

    setupPrefs = ["sys_integration_type", "sys_sis", "sys_timezone_sis", "sys_timezone"];

    constructor(
        private elementRef: ElementRef,
        private cd: ChangeDetectorRef,
    ) {
        this.elementRef.nativeElement.angBridge = this;
    }

    async ngOnInit() {
        await this.createSystemSetupList();

        this.init = true;
        this.cd.detectChanges();
    }

    async getPreferenceData() {
        const prefNames = [
            "init_enabled",
            "hist_sis_enabled",
            "hist_r25_enabled",
            "imp_enabled",
            "exp_enabled",
            "api_dispatcher_enabled",
            "sys_client_patch_enabled",
            "sys_sis_dbms",
            "api_instance",
            "sys_sis_subtype",
        ];

        const prefs = await LynxPrefsService.getPreferences(this.setupPrefs.concat(...prefNames));
        return prefs;
    }

    async createSystemSetupList() {
        const prefs = await this.getPreferenceData();

        const getDispValue = (pref: LynxPrefs.Data) => {
            switch (pref.prefName) {
                case "sys_sis": //Include subtype in display
                    return {
                        name: pref.prefNameDisp,
                        value: `${pref.prefValueDesc} (${prefs.find((p) => p.prefName === "sys_sis_subtype").prefValueText})`,
                    };
                case "sys_integration_type":
                    return getIntegrationTypeValue(pref);
                default:
                    return {
                        name: pref.prefNameDisp,
                        value: pref.prefValueDesc,
                    };
            }
        };

        const getIntegrationTypeValue = (pref: LynxPrefs.Data) => {
            if (pref.prefValueId === 2) {
                const apiInstance = prefs.find((p) => p.prefName === "api_instance");
                return {
                    name: apiInstance.prefNameDisp,
                    value: apiInstance.prefValueText,
                };
            } else {
                //loadClientInfo???? TODO: what does this include?
                const dbms = prefs.find((p) => p.prefName === "sys_sis_dbms");
                return {
                    name: dbms.prefNameDisp,
                    value: dbms.prefValueText,
                };
            }
        };

        this.systemSetup = prefs
            .filter((pref) => this.setupPrefs.includes(pref.prefName))
            .map((pref) => {
                return getDispValue(pref) as {
                    name: LynxPrefs.PrefNames;
                    value: string;
                };
            });
    }
}
